<form [formGroup]="form">
  <!--- Måler og detaljer --->
  @if (form.get('detailCharacteristics.subType')?.value === MeteringPointSubType.Physical) {
    <app-guide-card
      [fullWidth]="fullWidth"
      [valid]="(form.get('detailMeterCharacteristic.identification')?.valid || form.get('detailMeterCharacteristic.identification')?.disabled) &&
      (form.get('detailMeterCharacteristic.numberOfDigits')?.valid || form.get('detailMeterCharacteristic.numberOfDigits')?.disabled) &&
      (form.get('detailMeterCharacteristic.unitType')?.valid || form.get('detailMeterCharacteristic.unitType')?.disabled) &&
      (form.get('detailMeterCharacteristic.meterReadingType')?.valid  || form.get('detailMeterCharacteristic.meterReadingType')?.disabled)"
    >
      <div title>
        {{ 'meteringPoint.create.meter.title' | translate }}
      </div>
      <div description>
        {{ 'meteringPoint.create.meter.description' | translate }}
      </div>
      <div>
        <fieldset formGroupName="detailMeterCharacteristic">
          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.meterNumber' | translate }}</label>
            <input appInput formControlName="identification" [placeholder]="'meteringPoint.create.meterNumber' | translate">
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.numberOfDigits' | translate }}</label>
            <input appInputFixedDigits formControlName="numberOfDigits" [placeholder]="'meteringPoint.create.numberOfDigits' | translate">
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.meterReadingUnit' | translate }}</label>
            <select appSelect [collection]="unitTypeList" formControlName="unitType"></select>
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.meterReadingType' | translate }}</label>
            <select appSelect [collection]="meterReadingTypeList" formControlName="meterReadingType"></select>
          </app-input-group>
        </fieldset>
      </div>
    </app-guide-card>
  }
</form>
